import React from "react";

const ErrorIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M28.3333315,13.3452375 L26.6547603,11.6666665 L19.999999,18.3214278 L13.3452375,11.6666665 L11.6666665,13.3452375 L18.3214278,19.999999 L11.6666665,26.6547603 L13.3452375,28.3333315 L19.999999,21.67857 L26.6547603,28.3333315 L28.3333315,26.6547603 L21.67857,19.999999 L28.3333315,13.3452375 Z M19.9833316,3.33333313 C10.7833331,3.33333313 3.33333313,10.7999994 3.33333313,19.9999988 C3.33333313,29.1999989 10.7833331,36.6666645 19.9833316,36.6666645 C29.1999989,36.6666645 36.6666645,29.1999989 36.6666645,19.9999988 C36.6666645,10.7999986 29.1999989,3.33333313 19.9833316,3.33333313 Z"
        id="path-1"
      />
    </defs>
    <g id="Alert/Mixin/Icon/Error" fill="none" fillRule="evenodd">
      <g id="Alert-Icon">
        <g id="Icon/Alert/Failure">
          <mask id="mask-2" fill="#fff">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="Fill-2" fill="#000" xlinkHref="#path-1" />
          <g id="Colors/Red" mask="url(#mask-2)" fill="#ed125f">
            <rect id="foo" width="40" height="40" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ErrorIcon;
